import api from "./api";

export async function changeRequiredPassword(payload: {
  old_password: string;
  password: string;
  password_confirmation: string;
}): Promise<string> {
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("usuário não autenticado");
    }

    const response = await api.post(
      "/change-required-password",
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data?.message || "Senha alterada com sucesso";
  } catch (error: any) {
    const apiMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.response?.data?.errors?.old_password?.[0] ||
      error?.response?.data?.errors?.password?.[0];

    throw new Error(apiMessage || "Não foi possível alterar a senha.");
  }
}
